import React from 'react';
import { X } from 'lucide-react';

/**
 * Export Configuration Modal
 * Allows users to configure export parameters (scope, period, format)
 */
function ExportModal({ show, config, onConfigChange, onClose, onExport }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      data-modal-backdrop
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="p-6 border-b">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900">Configurer l&apos;export</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">P&eacute;rim&egrave;tre</label>
            <select
              value={config.scope}
              onChange={(e) => onConfigChange({ ...config, scope: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="fleet">Flotte compl&egrave;te</option>
              <option value="compliance">Conformit&eacute; uniquement</option>
              <option value="costs">Co&ucirc;ts uniquement</option>
              <option value="risks">Risques uniquement</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">P&eacute;riode</label>
            <select
              value={config.period}
              onChange={(e) => onConfigChange({ ...config, period: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="week">Cette semaine</option>
              <option value="month">Ce mois</option>
              <option value="quarter">Ce trimestre</option>
              <option value="year">Cette ann&eacute;e</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Format</label>
            <select
              value={config.format}
              onChange={(e) => onConfigChange({ ...config, format: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="csv">CSV (Excel)</option>
              <option value="pdf">PDF</option>
            </select>
          </div>
        </div>
        <div className="p-4 border-t bg-gray-50 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
            Annuler
          </button>
          <button
            onClick={onExport}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Exporter
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExportModal;
